import React from 'react';

interface InstagramOutlineIconProps {
  size?: number;
  color?: string;
}

/** Ícone do Instagram em stroke — sem o degradê da marca, por decisão de spec. */
const InstagramOutlineIcon: React.FC<InstagramOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke={color} strokeWidth="1.7" />
      <circle cx="12" cy="12" r="4.2" stroke={color} strokeWidth="1.7" />
      <circle cx="17.2" cy="6.8" r="1.1" fill={color} />
    </svg>
  );
};

export default InstagramOutlineIcon;
